"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWidgetDragEndHandler = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../../model");
/**
 * @internal
 */
function useWidgetDragEndHandler() {
    var dispatch = model_1.useDashboardDispatch();
    return react_1.useCallback(function () {
        dispatch(model_1.uiActions.clearDraggingWidgetSource());
        dispatch(model_1.uiActions.clearDraggingWidgetTarget());
    }, [dispatch]);
}
exports.useWidgetDragEndHandler = useWidgetDragEndHandler;
//# sourceMappingURL=useWidgetDragEndHandler.js.map